/**
 * @generated SignedSource<<21c6662f6bf1ce3ed0073d776ca1982e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGraphQLType_query$data = {
  readonly graphqlType: string | null | undefined;
  readonly " $fragmentType": "useGraphQLType_query";
};
export type useGraphQLType_query$key = {
  readonly " $data"?: useGraphQLType_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGraphQLType_query">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useGraphQLType_query"
};

(node as any).hash = "d7bc93a5f989cf915a2a2e232537c236";

export default node;
